import React from 'react';

export default function Select({
  label, name, value, onChange, options = [],
  placeholder, error, required = false, style,
}) {
  return (
    <div style={{ marginBottom: 'var(--sp-lg)', ...style }}>
      {label && (
        <label
          htmlFor={name}
          style={{
            display: 'block',
            marginBottom: 'var(--sp-xs)',
            fontSize: 'var(--font-size-base)',
            color: error ? 'var(--color-danger-text)' : 'var(--color-text-secondary)',
            fontWeight: '600',
          }}
        >
          {label}
          {required && <span style={{ color: 'var(--color-danger)' }}> *</span>}
        </label>
      )}
      <select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        style={{
          width: '100%',
          padding: '10px 12px',
          border: `1px solid ${error ? 'var(--color-danger)' : 'var(--color-border)'}`,
          borderRadius: 'var(--radius-sm)',
          fontSize: 'var(--font-size-base)',
          boxSizing: 'border-box',
          backgroundColor: 'var(--color-white)',
          outline: 'none',
          cursor: 'pointer',
        }}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {error && (
        <div style={{
          fontSize: 'var(--font-size-xs)',
          color: 'var(--color-danger-text)',
          marginTop: 'var(--sp-xs)',
        }}>{error}</div>
      )}
    </div>
  );
}
